<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
        <div class="lg:mb-2">
          <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('historical.fechaEvento')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.from')}}</label>
                      <el-form-item prop="fechaDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.to')}}</label>
                      <el-form-item prop="fechaHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('historical.evento')}}</label>
              <el-form-item prop="evento">
                <base-el-select class="w-full" :options="valuesTiposEvento" v-model="form.evento.value" clearable filterable/>
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('historical.info')}}</label>
              <el-form-item prop="mensaje">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.mensaje.value"
                  maxlength="500"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getHistoricalEvents } from '@/services/historical/getHistoricalEvents'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default {
  name: 'filter-panel',
  props: {
    vuexnamespace: {
      type: String,
      required: true,
    },
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      form: {
        evento: { label: i18n.t('historical.event_name'), value: '' },
        mensaje: { label: i18n.t('historical.info'), value: '' },
        fechaDesde: { label: i18n.t('historical.fechaDesde'), value: '' },
        fechaHasta: { label: i18n.t('historical.fechaHasta'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      valuesTiposEvento: []
    }
  },
  mounted: async function () {
    const tipoEvento = { tipo: this.$store.getters[this.vuexnamespace + '/getTipoEvento'] }
    const data = await getHistoricalEvents(tipoEvento)
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    }
    if (data.listaEventos.length > 0) {
      data.listaEventos.forEach(element => {
        this.valuesTiposEvento.push({ value: element, label: element.replaceAll('_', ' ') })
      })
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.evento.value = _temp.evento !== undefined && _temp.evento ? _temp.evento.value : ''
        this.form.mensaje.value = _temp.mensaje !== undefined && _temp.mensaje ? _temp.mensaje.value : ''
        this.form.fechaDesde.value = _temp.fechaDesde !== undefined && _temp.fechaDesde ? _temp.fechaDesde.value : ''
        this.form.fechaHasta.value = _temp.fechaHasta !== undefined && _temp.fechaHasta ? _temp.fechaHasta.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        evento: { label: i18n.t('historical.event_name'), value: '' },
        mensaje: { label: i18n.t('historical.info'), value: '' },
        fechaDesde: { label: i18n.t('historical.fechaDesde'), value: '' },
        fechaHasta: { label: i18n.t('historical.fechaHasta'), value: '' }
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
